module.exports = __webpack_public_path__ + "img/Grimmig.ad842f67.jpg";